<!-- TrainingInstitutionDetail.vue -->
<template>
    <myDialog 
        :isDialog="dialogVisible" 
        :title="title" 
        :width="'1200px'"
        @handleClose="handleClose"
    >
        <template slot="content">
            <!-- 详情内容区域 -->
            <div class="detail-content" v-if="detailData?.length > 0">
                <!-- 基本信息 -->
                <div class="section-container">
                    <div class="section-header">授课计划详情</div>
                    <div class="section-content">
                        <div class="plan-card" v-for="item in detailData" :key="item.id">
                            <div class="book-icon">
                                <img src="@/assets/images/training/book.png" alt="书籍">
                            </div>
                            <div class="plan-content">
                                <div class="plan-title">
                                   <span>{{ item.classType}}</span>
                                   <span>( {{ item.classDate }} {{ item.startTime }} ~ {{ item.endTime }})</span>
                                </div>
                                <div class="plan-details">
                                    <div class="course-details-left">
                                        <div class="detail-item">课时: {{item. classHours}}</div>
                                        <div class="detail-item">教师: {{ item.teacherName || '-' }}</div>
                                    </div>
                                    <div class="logistical-details-right">
                                        <div class="detail-item">地点: {{ item.location || '-' }}</div>
                                        <div class="detail-item">教学内容: {{ item.content || '-' }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            
            <!-- 加载状态 -->
            <div v-else-if="loading" class="loading-container">
                <el-skeleton animated>
                    <template #template>
                        <el-skeleton-item variant="text" style="width: 30%" />
                        <el-skeleton-item variant="text" style="width: 40%; margin-left: 24px;" />
                        <el-skeleton-item variant="text" style="width: 35%" />
                    </template>
                </el-skeleton>
            </div>
            
            <!-- 无数据状态 -->
            <div v-else class="no-data">
                <el-empty description="暂无数据" />
            </div>
        </template>
        
        <!-- 底部按钮（可选） -->
        <template slot="footer">
            <div class="dialog-footer">
                <el-button @click="handleClose">关闭</el-button>
                <!-- 可以添加其他操作按钮 -->
                <!-- <el-button type="primary" @click="handleEdit">编辑</el-button> -->
            </div>
        </template>
    </myDialog>
</template>

<script>
import '@/assets/css/base.css'
import { getTrainingClassTeachingPlan } from '@/api/training'
export default {
name: 'teachingPlan',
props: {
    isDialog: {
        type: [String, Boolean],
        default: false
    },
    title: {
        type: String,
        default: ''
    },
    classId:{
        type: String,
        default:""
    }
},
data() {
    return {
        dialogVisible: false, // 控制弹窗显示
        detailData: [],     // 详情数据
        loading: false,       // 加载状态
    }
},
methods: {
    // 打开弹窗
    openDialog(row) {
        this.dialogVisible = true
        // 优先使用传入的 row 参数中的 classId，如果没有则使用 props
        const id = (row && row.classId) ? row.classId : this.classId
        if (id) {
            this.loadDetailData(id)
        } else {
            // 如果没有 id，等待 props 更新后再加载
            this.$nextTick(() => {
                if (this.classId) {
                    this.loadDetailData(this.classId)
                }
            })
        }
    },
    
    // 关闭弹窗
    handleClose() {
        this.dialogVisible = false
        this.detailData = null
        this.currentRowId = null
        // 可以通知父组件弹窗已关闭
        this.$emit('dialog-closed')
    },
    
    // 从接口加载详情数据（如果需要）
    async loadDetailData(classId) {
        if (!classId) {
            this.loading = false
            return
        }
        this.loading = true
        try {
            const res = await getTrainingClassTeachingPlan({ classId })
            if (res.code === 200) {
                this.detailData = res.data
            }
        } catch (error) {
            console.error('加载详情失败:', error)
        } finally {
            this.loading = false
        }
    },
    
    // 复制父组件的诚信等级图标方法
    getIntegrityGradeIcon(gradeName) {
        if (!gradeName) return ''
        const upperName = String(gradeName).toUpperCase()
        if (upperName.includes('A')) {
            return 'rankA'
        } else if (upperName.includes('B')) {
            return 'rankB'
        } else if (upperName.includes('C')) {
            return 'rankC'
        }
        return ''
    },
    
    // 获取图标路径
    getIntegrityGradeIconSrc(gradeName) {
        const iconName = this.getIntegrityGradeIcon(gradeName)
        if (!iconName) return ''
        return require(`@/assets/images/custom-icons/${iconName}.svg`)
    },
    
},
// 监听父组件传递的isDialog变化（如果使用props控制）
watch: {
    isDialog: {
        handler(newVal) {
            // 如果isDialog是Boolean类型
            if (typeof newVal === 'boolean') {
                this.dialogVisible = newVal
            }
            // 如果isDialog是String类型（例如："true-机构基本信息"）
            else if (typeof newVal === 'string') {
                this.dialogVisible = newVal.includes('true')
            }
        },
        immediate: true
    }
}
}
</script>


<style lang="scss" scoped>
.myDialog {
/deep/ .el-dialog__header {
    height: 48px;
    line-height: 48px;
    font-size: 17px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: var(--vt-c-blue)!important;
}
        
/deep/ .el-dialog__title {
    color: #ffffff !important;
    font-weight: 700;
    font-size: 17px;
}
        
/deep/ .el-dialog__headerbtn {
    filter: brightness(0) invert(1) !important;
}
}

.detail-content {
    padding: 20px;

    .section-container {
        margin-bottom: 24px;
        
        &:last-child {
            margin-bottom: 0;
        }
    
        .section-header {
            display: flex;
            align-items: center;
            height: 40px;
            margin-bottom: 16px;
            &::before {
            content: '';
            width: 3px;
            height: 12px;
            background: var(--vt-c-blue-soft);
            margin-right: 8px;
        }
        
        &::after {
            content: '';
            flex: 1;
            height: 1px;
            border-top: 1px dashed #d3d4d6;
            margin-left: 8px;
        }
        }
    
        .detail-descriptions {
            /deep/ .el-descriptions__label {
                font-weight: 500;
                color: #606266;
                background: var(--vt-c-grey-mute);
            }
            
            /deep/ .el-descriptions__content {
                color: #303133;
            }
        }

        .section-content {
            margin: 20px 0;
            .plan-card {
                background: linear-gradient(98.33deg, rgba(249, 249, 249, 1) -3.39%, rgba(241, 246, 255, 1) 129.87%);
                border-radius: 4px;
                padding: 24px;
                display: flex;
                align-items: center;
                gap: 20px;
                margin-bottom: 20px;
                
                .book-icon {
                    width: 80px;
                    height: 80px;
                    flex-shrink: 0;
                    
                    img {
                        width: 100%;
                        height: 100%;
                        object-fit: contain;
                    }
                }
                
                .plan-content {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    gap: 16px;
                    
                    .plan-title {
                        font-size: 18px;
                        font-weight: 700;
                        color: var(--vt-c-black-mute-soft);
                        margin-bottom: 0;
                        display: flex;
                        align-items: center;
                        gap: 6px;
                    }
                    
                    .plan-details {
                        display: flex;
                        justify-content: left;
                        align-items: flex-start;
                        gap: 378px;
                        
                        .course-details-left {
                            display: flex;
                            flex-direction: column;
                            gap: 8px;
                            align-items: flex-start;
                            
                            .detail-item {
                                font-size: 14px;
                                font-weight: 400;
                                color:var(--vt-c-black);
                            }
                        }
                        
                        .logistical-details-right {
                            display: flex;
                            flex-direction: column;
                            gap: 8px;
                            align-items: flex-end;
                            text-align: right;
                            
                            .detail-item {
                                font-size: 14px;
                                font-weight: 400;
                                color:var(--vt-c-black);
                            }
                        }
                    }
                }
            }
        }
    }
}

</style>
